import { isKnownMarket } from './markets'

export const HOMES_ROUTE = '/homes'
export const MY_ACRE_ROUTE = '/my-acre'

const PREFERRED_MARKET_LOCAL_STORAGE_KEY = 'preferred-market'

export function getPreferredHomesRoute() {
  // Return default route during SSR
  if (typeof window === 'undefined') {
    return '/homes'
  }

  try {
    const item = localStorage.getItem(PREFERRED_MARKET_LOCAL_STORAGE_KEY)
    if (item === null) return '/homes'

    let market: unknown = undefined
    try {
      market = JSON.parse(item)
    } catch {
      localStorage.removeItem(PREFERRED_MARKET_LOCAL_STORAGE_KEY)
      return '/homes'
    }
    if (!isKnownMarket(market)) {
      // Stale or malformed values (e.g. the pre-ACR-20 'NC/greensboro') would
      // redirect to a permanently empty page; clear the entry so the picker
      // shows instead of the value being resurrected on the next visit.
      localStorage.removeItem(PREFERRED_MARKET_LOCAL_STORAGE_KEY)
      return '/homes'
    }

    return `/homes/${market}`
  } catch (error) {
    // Fallback for any localStorage errors
    console.warn(
      'Error accessing localStorage in getPreferredHomesRoute:',
      error
    )
    return '/homes'
  }
}
